var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.917 19.25L11 1.834 21.083 19.25H.917zm3.162-1.833h13.842L11 5.5 4.08 17.417zM11 16.5c.26 0 .477-.088.653-.263a.887.887 0 00.264-.653.887.887 0 00-.264-.654.887.887 0 00-.653-.263.887.887 0 00-.653.263.887.887 0 00-.264.654c0 .26.088.477.264.653A.887.887 0 0011 16.5zm-.917-2.75h1.834V9.167h-1.834v4.583z",
    fill: "currentColor"
  })));
}
export default SvgWarning;